import { SkipLink } from "./styles";

export const SkipToContent = () => (
  <SkipLink id="skip-link" href="#content">
    Skip to content
  </SkipLink>
);
